module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist",
      "id": _vm.crowdOrRais + 'tabs'
    }
  }, [_c('li', [_c('a', {
    staticClass: "first"
  }, [_vm._v(_vm._s(_vm.$t("project.show.campaignDetails")))])]), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#campaign-story",
      "aria-controls": "campaign-story",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.story")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#campaign-author",
      "aria-controls": "campaign-author",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t("author")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#campaign-backers",
      "aria-controls": "campaign-backers",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.backers")) + " " + _vm._s(_vm.contributions.length))])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#campaign-comments",
      "aria-controls": "campaign-comments",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.$t("comments")) + " " + _vm._s(_vm.comments.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "role": "tabpanel",
      "id": "campaign-story"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('project.storySlogan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('project.show.selectDescriptionLanguage')))]), _vm._v(" "), (_vm.project.translations) ? _c('div', {
    staticClass: "row select-language-buttons"
  }, _vm._l((_vm.project.translations), function(language) {
    return _c('div', {
      staticClass: "col-lg-4 col-xs-6"
    }, [_c('button', {
      staticClass: "select-language-btn sm text-center",
      class: [{
        crowd: _vm.project.crowdfunding,
        raise: !_vm.project.crowdfunding,
        active: language.locale === _vm.locale
      }],
      attrs: {
        "value": language.locale,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeLanguage(language.locale)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(("language." + (language.locale)))) + "\n              ")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.project.video_url) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    ref: "videoRef",
    attrs: {
      "src": _vm.project.video_url.replace('watch?v=', 'embed/'),
      "id": "video-container",
      "controls": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-30"
  }, [_c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.project.story)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "campaign-author"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.project.user.photo.thumb.url) ? _c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.user.photo.thumb.url
    }
  }) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "display": "inline",
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.project.user.full_name) + " "), (_vm.project.user.profession) ? _c('span', [_vm._v("(" + _vm._s(_vm.project.user.profession.name) + ")")]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "-text-center"
  }, [_vm._v(_vm._s(_vm.$t('profile.informationAboutUser')))]), _vm._v(" "), _c('p', {
    staticClass: "author-about",
    staticStyle: {
      "word-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.project.user.description)
    }
  }), _vm._v(" "), _c('h4', [(_vm.project.user.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.project.user.id
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('profile.viewFullProfile')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.team.length) ? _c('h3', {
    staticClass: "mt-50"
  }, [_vm._v(_vm._s(_vm.$t('project.show.OtherTeamMembers')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.team), function(member, index) {
    return _c('div', {
      key: index,
      staticClass: "team-members",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('div', [_c('div', {
      staticClass: "avatar"
    }, [(member.user.photo.thumb.url) ? _c('img', {
      attrs: {
        "src": _vm.$server_url + member.user.photo.thumb.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticStyle: {
        "display": "inline",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(member.user.full_name))])]), _vm._v(" "), _c('h4', [(member.user.id) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'show_profile',
          params: {
            id: member.user.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('profile.viewFullProfile')) + "\n          ")]) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "campaign-backers"
    }
  }, _vm._l((_vm.contributions), function(contribution) {
    return _c('div', {
      staticClass: "backer"
    }, [(contribution.anonymous) ? _c('p', [_vm._v(_vm._s(_vm.$t('anonymous')))]) : _c('div', [(contribution.user.photo.thumb.url) ? _c('div', {
      staticClass: "avatar small"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'show_profile',
          params: {
            id: contribution.user.id
          }
        }
      }
    }, [(_vm.project.user.photo.thumb.url) ? _c('img', {
      attrs: {
        "src": _vm.$server_url + contribution.user.photo.thumb.url
      }
    }) : _c('img', {
      attrs: {
        "src": require("assets/img/specialist.jpg")
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'show_profile',
          params: {
            id: contribution.user.id
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(contribution.user.full_name))])])], 1), _vm._v(" "), _c('span', {
      staticClass: "when"
    }, [_vm._v(_vm._s(_vm._f("daysLeft")(contribution.created_at)) + " " + _vm._s(_vm.$t('daysAgo')))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("currencySymbol")(_vm.project.currency)) + _vm._s(contribution.amount))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "campaign-comments"
    }
  }, [_c('transition-group', {
    staticClass: "scroll-list",
    attrs: {
      "name": "list",
      "tag": "p"
    }
  }, _vm._l((_vm.comments), function(comment) {
    return _c('p', {
      key: comment.id,
      staticClass: "comment"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'show_profile',
          params: {
            id: comment.user.id
          }
        }
      }
    }, [(comment.user.photo.thumb.url) ? _c('div', {
      staticClass: "avatar",
      staticStyle: {
        "height": "60px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "src": _vm.$server_url + comment.user.photo.thumb.url
      }
    })]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(comment.user.full_name))])]), _vm._v(" "), _c('span', {
      staticClass: "when"
    }, [_vm._v(_vm._s(_vm._f("daysLeft")(comment.created_at)) + " " + _vm._s(_vm.$t('daysAgo')))]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(comment.body) + "\n        ")], 1)
  }), 0), _vm._v(" "), (_vm.user.email) ? _c('form', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.body),
      expression: "comment.body"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "leave-comment",
      "placeholder": _vm.$t('project.show.leaveComment')
    },
    domProps: {
      "value": (_vm.comment.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comment, "body", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg crowdfunding button-center-' + _vm.crowdOrRais,
    attrs: {
      "type": "button",
      "disabled": !_vm.comment.body
    },
    on: {
      "click": _vm.addComment
    }
  }, [_vm._v(_vm._s(_vm.$t("send")))])]) : _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('project.show.logInToAddComment')))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6663c258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Show/Details.vue
// module id = 811
// module chunks = 1